module.exports = __webpack_public_path__ + "static/SoleilExtraBold-c9cb6ac2e240a959af92e196dac68dc4.otf";